import React from "react";
import ToDoList from "./ToDoList";


const App = () => {
  return (
    <ToDoList />
  )
}

export default App;
